import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/parent-homeworks', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/parent-homeworks/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/parent-homeworks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = ({ id, data }) => {
  return httpClient
    .put(`/api/parent-homeworks/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const download = (Options = {}) => {
  return httpClient
    .get('/api/files', { responseType: 'arraybuffer', ...Options })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  download
}
